var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-refund-reasons" },
    [
      _c(
        "el-select",
        {
          staticClass: "item-refund-reason-select",
          attrs: {
            value: _vm.selectedReason,
            placeholder: "Select refund reason",
            "popper-class": "item-refund-reason-dropdown",
          },
          on: { change: _vm.emitSelected },
        },
        _vm._l(_vm.refundReasons, function (reason) {
          return _c(
            "el-option",
            {
              key: reason.id,
              staticClass: "item-refund-reason-option",
              attrs: { label: reason.text, value: reason.id },
            },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(reason.text)),
              ]),
              _vm._v(" "),
              _vm.selectedReason === reason.id && _vm.showCheckMark
                ? _c("span", { staticStyle: { float: "right !important" } }, [
                    _c("img", {
                      staticStyle: {
                        height: "12.28px",
                        width: "15.78px",
                        "padding-top": "5px",
                      },
                      attrs: {
                        src: _vm.icons.dropDownCheckmark,
                        alt: "selected",
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }